<mat-toolbar class="toolbar mat-toolbar--autosize" color="primary">
  <div class="header">
    <ng-content></ng-content>
  </div>
</mat-toolbar>
